var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("苏ICP备17070040号-1")]),_vm._v(" ©   All rights reserved 南京水晶视界数字科技有限公司")])])
}]

export { render, staticRenderFns }